module.exports = __webpack_public_path__ + "static/media/collection.e4c570eb.svg";